/**
 * Scrollbars for the main stream scroller.
 */
import * as React from 'react';

import Scrollbars from 'react-custom-scrollbars';
import { inject } from 'mobx-react';
// import { last } from 'lodash';
import { StreamStore, ScrollDirection } from '../../../stores/StreamStore';
import { PostStore } from '../../../stores/PostStore';
import { observe } from 'mobx';

interface ScrollerProps {
    current: number;
    onNewPost: (idx: number) => void;
    onScroll: (pos: number) => void;
    scroll: number;
}

/**
 * Scrollbar component, tracks the last scroll position and observes a scrollchange in the StreamStore.
 * 
 * @class Scroller
 * @extends {(React.Component<ScrollerProps & { streamStore?: StreamStore, postStore?: PostStore }>)}
 */
@inject((allStores) => ({
    streamStore: allStores.streamStore as StreamStore,
    postStore: allStores.postStore as PostStore
}))
class Scroller extends React.Component<ScrollerProps & { streamStore?: StreamStore, postStore?: PostStore }> {
    currentPost = this.props.current;
    lastScrollPos = 0;
    direction = ScrollDirection.DOWN;
    scrollRef: Scrollbars;

    componentDidMount() {
        this.scrollRef.scrollTop(this.props.scroll);
        observe(this.props.postStore!.posts, () => {
            this.scrollRef.scrollTop(this.lastScrollPos);
        });
    }

    onScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const container = event.target as HTMLDivElement;
        const scroll    = container.scrollTop;
        
        if (scroll > this.lastScrollPos) {
            this.direction = ScrollDirection.DOWN;
        } else {
            this.direction = ScrollDirection.UP;
        }

        this.lastScrollPos = scroll;
        this.props.onScroll(scroll);
        this.props.streamStore!.scrollDirection = this.direction;
        this.props.streamStore!.scrollLocation = scroll;
    }

    render() {
        return (
            <Scrollbars 
                ref={ref => ref && (this.scrollRef = ref)} 
                onScroll={this.onScroll}
            >
                {this.props.children}
            </Scrollbars>
        );
    }
}

export { Scroller };



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Stream/ScrollBar/ScrollBar.tsx